<template>
  <div>
    <template v-for="routine in routines">
      <Routine
        :key="routine.id"
        :routine="routine"
        class="mb-2"
      />
  </template>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Routine from './Routine'

export default {
  components: {
    draggable,
    Routine
  },
  data () {
    return {
      dragging: false,
      routines: [
        {
          id: 111,
          title: 'Be a nice person',
          startedOn: new Date(2020, 10, 3),
          frequency_count: null,
          frequency_period: 'daily',
          preferred_days: [],
        },
        {
          id: 1,
          title: 'Yoga',
          startedOn: new Date(2020, 10, 2),
          frequency_count: 3,
          frequency_period: 'week',
          preferred_days: [],
        },
        {
          id: 2,
          title: 'Play Tenis',
          startedOn: new Date(2020, 10, 5),
          frequency_count: 1,
          frequency_period: 'week',
          preferred_days: [],
        },
        {
          id: 3,
          title: 'Do Streching',
          startedOn: new Date(),
          frequency_count: 5,
          frequency_period: 'week',
          preferred_days: [],
        },
        {
          id: 4,
          title: 'Check a startupjobs.cz',
          startedOn: new Date(2020, 10, 15),
          frequency_count: 1,
          frequency_period: 'month',
          preferred_days: [],
        },
      ]

      // addSubTaskSkeleton: null
    }
  },
  methods: {
    sortById () {
      this.tasks = this.tasks.sort((a, b) => a.id - b.id)
    }
  }
}

</script>

<style lang="scss">
</style>
